import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {NewComment} from '../../types'

import {CommentsQueryKey, getCommentsPath} from './useComments'

export const useCreateComment = (
  locationId: string,
  options?: UseMutationOptions<never, AxiosError, NewComment>
) => {
  const queryClient = useQueryClient()

  return useMutation<never, AxiosError, NewComment>({
    ...options,
    mutationFn: async (newCommentData) => {
      const response = await ApiClient.axiosInstance.post<never>(
        getCommentsPath(locationId),
        newCommentData
      )
      return response.data
    },
    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({queryKey: [CommentsQueryKey]})
      await options?.onSuccess?.(data, variables, onMutateResult, context)
    }
  })
}
